<template>
  <form
    action="https://example.com/subscribe"
    method="POST"
    @submit.prevent="onSubmit()"
    :class="{ 'pointer-events-none': submitting, 'opacity-60': submitting }"
  >
    <div v-if="!success">
      <div class="flex gap-2">
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          required
          v-model="email"
          @focus="onFocus()"
          class="w-full rounded border border-grayBorder bg-transparent px-3 py-2 text-xs outline-none focus:border-black focus:ring-black focus:max-sm:text-base"
        />
        <button type="submit" class="btn font-bold">Subscribe</button>
      </div>
      <div v-if="errorMessage" class="w-full text-xs text-red-600">
        {{ errorMessage }}
      </div>
    </div>
    <div v-else class="text-sm">
      <p class="mt-4">
        Thank you for joining the community, keep an eye on your inbox to
        confirm your subscription.
      </p>
    </div>
  </form>
</template>

<script setup lang="ts">
import { emailSchema } from "~/shared/zod/subscribe/emailSchema"

const email = ref("")
const submitting = ref(false)
const success = ref(false)
const errorMessage = ref("")

const emit = defineEmits<{
  (e: "success"): void
}>()

const onFocus = () => {
  errorMessage.value = ""
}

const onSubmit = async () => {
  // Handle form submission logic here
  const parseEmail = emailSchema.safeParse(email.value)

  if (!parseEmail.success) {
    errorMessage.value = parseEmail.error.issues[0].message
    return
  }

  console.log(`Subscribing with email: ${parseEmail.data}`)
  submitting.value = true

  await $fetch("/api/subscribe", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email: parseEmail.data }),
  })

  submitting.value = false
  email.value = ""
  success.value = true
  emit("success")
}
</script>
